const Index = () => import('./index.vue');

export default [
    {
        path: '/subscribers',
        name: 'SubscribersPage',
        component: Index
    }
]